import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-column-two-vertical",
  templateUrl: "./med-icon-column-two-vertical.component.html",
})
export class MedIconColumnTwoVerticalComponent extends SvgMixinComponent {}
